import React, {Component} from "react";
import {DialogActions} from "@material-ui/core";
import {Button} from "react-bootstrap";
import {Dropdown} from "primereact/dropdown";
import {InputTextarea} from "primereact/inputtextarea";
import ValidationUtil from "../../../components/form/validator/ValidationUtil";
import {FormField} from "../../../components/form";
import EnumManagementType from "../enums/EnumManagementType";
import EnumBlockType from "../enums/EnumBlockType";
import RotationBlockRemoteService from "../RotationBlockRemoteService";
import DateUtil from "../../../utils/DateUtil";

export default class SetAsManagementTimeModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            managementType: null,
            comments: ''
        };
    }

    save = () => {
        if (!ValidationUtil.checkWithNotification(this.formFields)) {
            return;
        }

        const {event, onSave, close} = this.props;

        const updatedEvent = {
            ...event,
            managementType: this.state.managementType,
            comments: this.state.comments
        };

        RotationBlockRemoteService.updateBlockType(updatedEvent, EnumBlockType.MANAGEMENT.key, () => {
            close();
            if (onSave) {
                onSave();
            }
        });
    }

    render() {
        this.formFields = [];
        const {event, timezone} = this.props;

        return (
            <>
                <div className="container" style={{width: 400}}>
                    <div className="row">
                        <div className="col-5">Time</div>
                        <div className="col-7">
                            {event.startMoment.tz(timezone).format("HH:mm")} - {event.endMoment.tz(timezone).format("HH:mm")}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-5">Block Type</div>
                        <div className="col-7">
                            <FormField ref={formField => this.formFields.push(formField)}
                                       required validateOn={this.state.managementType}>
                                <Dropdown optionLabel="name" optionValue="key"
                                          options={Object.values(EnumManagementType.values())}
                                          value={this.state.managementType}
                                          placeholder="Select type"
                                          appendTo={document.body}
                                          onChange={e => this.setState({managementType: e.value})}/>
                            </FormField>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-5">Comments</div>
                        <div className="col-7">
                            <FormField ref={formField => this.formFields.push(formField)}
                                       required validateOn={this.state.comments}>
                                <InputTextarea
                                    value={this.state.comments}
                                    onChange={e => this.setState({comments: e.target.value})}
                                    rows={3}
                                    maxLength={500}
                                    placeholder="Enter comments..."
                                    style={{width: '100%'}}
                                />
                            </FormField>
                        </div>
                    </div>
                </div>
                <DialogActions>
                    <Button variant="success" onClick={this.save}>Save</Button>
                </DialogActions>
            </>
        );
    }
}
